const transl = (t, translation) => {
    return t(`${translation.key}`);
};
export default transl;